import React from 'react';

const Occupation = ({ updateProfile, profileData }) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    updateProfile(name, value);
  };

  return (
    <fieldset className="form-group form-group--no-validation">
      <legend className="form-group__title">Occupation</legend>
      <span className="form-group__radio">
        <input
          name="occupation"
          type="radio"
          value="professional"
          id="professional"
          onChange={handleChange}
          checked={profileData.occupation === 'professional'}
        ></input>
        <label htmlFor="professional">Professional</label>
      </span>
      <span className="form-group__radio">
        <input
          name="occupation"
          type="radio"
          value="student"
          id="student"
          onChange={handleChange}
          checked={profileData.occupation === 'student'}
        ></input>
        <label htmlFor="student">Student</label>
      </span>
      <span className="form-group__radio">
        <input
          name="occupation"
          type="radio"
          value="other"
          id="otherOccupation"
          onChange={handleChange}
          checked={profileData.occupation === 'other'}
        ></input>
        <label htmlFor="otherOccupation">Other</label>
      </span>
    </fieldset>
  );
};

export default Occupation;
